import axios, { type AxiosRequestConfig, type AxiosError } from 'axios';

/**
 * Vlastní Axios instance pro orval generated client.
 * Všechny API požadavky procházejí touto instancí.
 */
export const axiosInstance = axios.create({
  // Prázdná baseURL zajistí, že cesty jsou root-relative
  // a fungují stejně v developmentu (proxy) i produkci (same-host)
  baseURL: '',
  headers: {
    'Content-Type': 'application/json',
  },
  // Pole v query serializuj jako opakovaný klíč bez závorek (`ids=1&ids=2`), ne axios default
  // `ids[]=1&ids[]=2`. ASP.NET minimal API binduje `int[]? ids` jen z opakovaného klíče — jinak
  // filtr (např. resolveByIds v selektorech) nedorazí a endpoint vrátí celou tabulku.
  paramsSerializer: { indexes: null },
});

/** GET /api/* nesmí jít z browser disk cache (starý SPA HTML fallback byl tichý []). */
axiosInstance.interceptors.request.use((config) => {
  if (config.method?.toLowerCase() === 'get' && config.url?.startsWith('/api')) {
    config.headers = axios.AxiosHeaders.from(config.headers);
    config.headers.set('Cache-Control', 'no-cache');
    config.headers.set('Pragma', 'no-cache');
  }
  return config;
});

/**
 * Custom instance pro orval mutator.
 * Vrací data z response nebo vyhodí chybu.
 */
export const customInstance = async <T>(config: AxiosRequestConfig): Promise<T> => {
  const response = await axiosInstance.request<T>(config);
  return response.data;
};

// Export typu pro error handling
export type ErrorType<T> = AxiosError<T>;
